import React from 'react';
import { IconProps } from '.';

const SvgLink = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M18.309 5.691c-1.28-1.278-3.432-1.267-4.81.111L10.841 8.46c-1.377 1.378-1.39 3.53-.11 4.81L9.67 14.33c-1.902-1.902-1.815-5.005.11-6.93L12.44 4.74c1.925-1.925 5.028-2.012 6.93-.11 1.902 1.902 1.815 5.005-.11 6.93l-1.061-1.06c1.378-1.378 1.39-3.53.11-4.81l.53-.53-.53.53Zm-5.15 9.849c1.377-1.378 1.39-3.53.11-4.81l1.061-1.06c1.902 1.902 1.815 5.005-.11 6.93L11.56 19.26c-1.925 1.925-5.028 2.012-6.93.11-1.902-1.902-1.815-5.005.11-6.93l1.061 1.06c-1.378 1.378-1.39 3.53-.11 4.81l-.531.53.53-.53c1.28 1.278 3.432 1.267 4.81-.111l2.658-2.658Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgLink;
